import LanguagesPage from './Languages.page';

export default LanguagesPage;
